"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartHoverTooltip = exports.BaseTooltipPositioner = void 0;
var _palette = require("@artsy/palette");
var _themeGet = require("@styled-system/theme-get");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MousePositionContext = require("./MousePositionContext");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var LABEL_OFFSET = 10;

/**
 * Tooltip for bar and line charts
 */
var ChartHoverTooltip = function ChartHoverTooltip(_ref) {
  var children = _ref.children;
  var ref = (0, _react.useRef)(null);
  var _useContext = (0, _react.useContext)(_MousePositionContext.MousePositionContext),
    x = _useContext.x,
    y = _useContext.y;
  if (ref.current) {
    // position outside of the render loop to avoid GC churn
    ref.current.style.top = y - LABEL_OFFSET - ref.current.offsetHeight + "px";
    ref.current.style.left = x + "px";
  }
  return /*#__PURE__*/_react.default.createElement(HoverTooltipPositioner, {
    ref: ref
  }, children);
};
exports.ChartHoverTooltip = ChartHoverTooltip;
ChartHoverTooltip.displayName = "ChartHoverTooltip";
/**
 * Base component for positioning tooltips
 */
var BaseTooltipPositioner = (0, _styledComponents.default)(_palette.Flex).withConfig({
  displayName: "ChartHoverTooltip__BaseTooltipPositioner",
  componentId: "sc-2qa7c8-0"
})(["transform:translateX(-50%);pointer-events:none;border-radius:2px;"]);
exports.BaseTooltipPositioner = BaseTooltipPositioner;
var HoverTooltipPositioner = (0, _styledComponents.default)(BaseTooltipPositioner).withConfig({
  displayName: "ChartHoverTooltip__HoverTooltipPositioner",
  componentId: "sc-2qa7c8-1"
})(["", ";z-index:2;position:fixed;background-color:", ";box-shadow:", ";"], _palette.media.xs(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))), (0, _themeGet.themeGet)("colors.white100"), (0, _themeGet.themeGet)("effects.dropShadow"));
//# sourceMappingURL=ChartHoverTooltip.js.map